import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import classNames from "classnames";
import { useDispatch } from "react-redux";
// import appUrl from "../../../config/appUrl";
import { Image } from "primereact/image";
import appUrl from "../../../config/appUrl";
const AddEditVehicleType = ({
  onHide,
  getVehicleTypeList,
  addEditVehicleType,
  vehicleTypeId,
}) => {
  const [imageBase64, setImageBase64] = useState("");
  const [iconEdit, setIconEdit] = useState("");

  const handleImageChange = (e) => {
    const fileSize = e.target.files[0].size;

    if (fileSize < 1000000) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        setImageBase64(reader.result);
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    } else {
      e.target.value = null; // clear the input field
      return;
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("This field is required.")
      .max(20, "max limit is 20"),
    icon: Yup.mixed().required("This field is required."),
    // fee: Yup.number().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      name: "",
      icon: "",
      // fee: "",
    },

    onSubmit: async (data) => {
      data["icon"] = imageBase64;

      if (addEditVehicleType) {
        data["categoryId"] = vehicleTypeId;

        // handle editing user
        try {
          const response = await fetch(
            `${appUrl.BASE_URL}category`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );

          if (response?.status === 201 || response?.status === 200) {
            await getVehicleTypeList();
          }
          onHide();
        } catch (error) {
          console.error(error);
        }
      } else {
        try {
          const response = await fetch(
            `${appUrl.BASE_URL}category`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );
          if (response?.status === 201 || response?.status === 200) {
            await getVehicleTypeList();
          }
          onHide();
        } catch (error) {
          console.error(error);
        }
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const getVehicleTypeById = async () => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}category/getById?categoryId=${vehicleTypeId}`
      );
      const keyData = await response.json();
      setIconEdit(keyData?.icon);

      Object.keys(keyData).forEach((key) => {
        if (formik.initialValues.hasOwnProperty(key)) {
          formik.setFieldValue(key, keyData[key]);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      vehicleTypeId !== undefined &&
      vehicleTypeId !== null &&
      addEditVehicleType === true
    ) {
      getVehicleTypeById();
    }
  }, []);

  return (
    <div>
      <h5>{addEditVehicleType ? "Edit Vehicle Type" : "Add Vehicle Type"}</h5>
      <div className="brdr__top">
        <form onSubmit={formik.handleSubmit}>
          <div className="card">
            <div className="p-fluid formgrid grid">
              <div className="field col-12 md:col-6">
                <label style={{ fontWeight: "bold" }}> Vehicle Name </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="name"
                  name="name"
                  keyfilter={/^[^<>*!0123456789]+$/}
                  value={formik.values.name}
                  onChange={(event) => {
                    const inputValue = event.target.value;
                    if (inputValue.length <= 20) {
                      formik.handleChange(event);
                    }
                  }}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("name") },
                    "TextArea__Round"
                  )}
                  type="text"
                />
                {getFormErrorMessage("name")}
              </div>

              {/* <div className="field col-12 md:col-12">
                                <label style={{ fontWeight: "bold" }}> Fee </label><span className="Label__Required">*</span>
                                <InputText id="fee" name="fee" value={formik.values.fee} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("fee") }, "TextArea__Round")} type="number" min={0} />
                                {getFormErrorMessage("fee")}
                            </div> */}

              <div className="field col-12 md:col-6">
                <label style={{ fontWeight: "bold" }}>Icon</label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <br />
                <div className="icon-field flex align-items-center">
                  <input
                    id="icon"
                    name="icon"
                    className={classNames(
                      { "p-invalid": isFormFieldValid("icon") },
                      "fileUploadBtn"
                    )}
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      handleImageChange(e);
                      formik.handleChange(e);
                    }}
                  />
                  {getFormErrorMessage("icon")}
                  {addEditVehicleType && (
                    <div className="vehicle-icon pl-4">
                      {!imageBase64 && (
                        <Image
                          src={appUrl.baseUrlImg + iconEdit}
                          alt="Vehicle Image"
                          preview
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>

              <br />

              <div className="col-12 text-center mt-6 flex justify-content-end">
                <Button
                  label="Cancel"
                  className="Cancel__button mr-3"
                  type="button"
                  onClick={onHide}
                />
                <Button
                  type="submit"
                  className="Save__Button"
                  label={addEditVehicleType ? "Update" : "Save"}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditVehicleType;
